<script>
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    components: {
        VueDatePicker,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        onChange: {
            type: Function,
            required: false
        }
    },
    computed: {
        model: {
            get() {
                if (!this.value) return null

                return this.value;
            },
            set(val) {
                if (this.onChange)
                    this.onChange(val);
            },
        },
    },
}
</script>

<template>
    <VueDatePicker
        v-model="model"
        model-type="yyyy-MM-dd"
        :formats="{ input: 'dd/MM/yyyy' }"
        auto-apply
        :time-config="{ enableTimePicker: false }"
        teleport="body" />
</template>
